/**
 * CIENA — Free Shipping Bar controller
 * ---------------------------------------------------------------------------------------------------
 * O cart-drawer re-renderiza (innerHTML) a cada add / +/-, recriando a barra. Animações atreladas à
 * inserção piscavam/resetavam a cada update, e a celebração de "frete grátis" tocava 2x quando havia
 * mais de um re-render ao cruzar o threshold.
 *
 * Este controller mantém a seção ESTÁVEL: persiste o último valor (window) e, quando uma barra nova é
 * inserida, anima o preenchimento do valor ANTERIOR → NOVO (FLIP) — só a barrinha se move, sem reset.
 * A celebração do estado completo dispara UMA vez (só na transição incompleto → completo).
 * MutationObserver roda antes do paint, então não há flash do valor final.
 * ---------------------------------------------------------------------------------------------------
 */
(function () {
  if (window.__cienaFsbInit) return;
  window.__cienaFsbInit = true;

  var state = { scale: null, complete: false };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function num(v) {
    var n = parseFloat(v);
    return isNaN(n) ? 0 : n;
  }

  function processBar(bar) {
    if (!bar || bar.dataset.fsbReady === '1') return;
    bar.dataset.fsbReady = '1';

    var fill = bar.querySelector('.ciena-fsb__fill');
    if (!fill) return;

    var target = num(fill.getAttribute('data-scale'));
    var isComplete = bar.classList.contains('ciena-fsb--complete');
    var prev = state.scale === null ? 0 : state.scale;
    var wasComplete = state.complete;

    if (!reduce && prev !== target) {
      // FLIP: parte do valor anterior e anima até o novo (CSS var). Roda pré-paint → sem flash.
      fill.style.transition = 'none';
      fill.style.transform = 'scaleX(' + prev + ')';
      void fill.offsetWidth; // reflow
      requestAnimationFrame(function () {
        fill.style.transition = '';
        fill.style.transform = ''; // volta p/ scaleX(var(--fsb-scale)) = target, com transition
      });
    }

    // Celebração só na transição p/ completo (evita "pisca 2x" em re-renders repetidos)
    if (isComplete && !wasComplete && !reduce) {
      bar.classList.add('ciena-fsb--celebrate');
    }

    state.scale = target;
    state.complete = isComplete;
  }

  function scan() {
    var bar = document.querySelector('#CartDrawer .ciena-fsb');
    if (bar) processBar(bar);
  }

  function init() {
    var host = document.getElementById('CartDrawer');
    if (host) {
      new MutationObserver(scan).observe(host, { childList: true, subtree: true });
    }
    // Ao fechar a gaveta, zera o estado → na próxima abertura a barra cresce de 0 (intro).
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      new MutationObserver(function () {
        if (!drawer.classList.contains('active')) {
          state.scale = null;
          state.complete = false;
        }
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
    scan();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
